import { createSelector } from '@reduxjs/toolkit'

interface ConfirmEntry {
	action?: unknown
	[key: string]: unknown
}

interface ConfirmState {
	toConfirm: ConfirmEntry[]
}

const defaultConfirmState: ConfirmState = {
	toConfirm: [],
}

const selectconfirm = (state: Record<string, unknown>): ConfirmState => {
	const confirm = state.confirm
	if (!confirm || typeof confirm !== 'object') {
		return defaultConfirmState
	}
	const typed = confirm as ConfirmState
	if (Array.isArray(typed.toConfirm)) {
		return typed
	}
	return defaultConfirmState
}

export const selectIsConfirming = createSelector(selectconfirm, (confirm) => confirm.toConfirm.length > 0)

export default selectconfirm
